import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  Injector,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { TranslatableDropdownOption } from '../../../core/models';
import { isNullOrEmpty } from '../../../core/utils';
import { EnhancedFormControl } from '../../../models/rt-common';
import { BaseComponent } from '../../../shared/components';

@Component({
  selector: 'sigv-input-multi-select',
  templateUrl: './input-multi-select.component.html',
  styleUrls: ['./input-multi-select.component.css'],
})
export class InputMultiSelectComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  /** 如有設定則會顯示於 formValidate時的錯誤訊息 */
  @Input() fieldName?: string;
  /** 欲綁定formControl欄位名稱，如是字串格式，則資料以逗號(,)區隔，如資料格式是陣列，請標註 isStringFormat=false
   * @description useForm.controls['externalName']
   */
  @Input() bindingFormControl?: AbstractControl | any;
  /**資料是否是字串格式，預設為true */
  @Input() isStringFormat: boolean = true;
  /** 空值欲設提示 */
  @Input() placeholder?: string;
  /** 下拉選單選項 */
  @Input() selectOptions: TranslatableDropdownOption[] | SelectItem[] = [];
  /** 頁面是否純檢視*/
  @Input() isReadOnly: boolean = false;
  /** 是否開放編輯*/
  @Input() isDisabled: boolean = false;
  /**是否使用於可編輯表格內 */
  @Input() isUseInTable: boolean = false;
  /**變動事件 */
  @Output() onChange = new EventEmitter<void>();
  @Input() value: EnhancedFormControl<string[]> = new EnhancedFormControl<
    string[]
  >({
    isFormArray: true,
  });
  @Output() valueChange = new EventEmitter<EnhancedFormControl<string[]>>();

  useStyle = '';
  constructor(injector: Injector) {
    super(injector);
    this.useStyle = this.isUseInTable ? 'table-dropdown' : '';
  }

  private subscription: Subscription | undefined;
  render = true;

  onChangeEvent(event: any): void {
    this.onChange.emit(event);

    if (this.isStringFormat) {
      const arrayJoined = this.value.getRawValue().join(',');
      this.bindingFormControl.setValue(arrayJoined);
      this.bindingFormControl.reset = () => {
        this.bindingFormControl.value = '';
        this.value.setValue([]);
      };
    } else {
      this.bindingFormControl.setValue(event.value);
    }
  }

  setValueData = (): void => {
    this.logger.debug('valueData', this.bindingFormControl?.getRawValue());
    if (this.isStringFormat) {
      let valueArray =
        this.bindingFormControl?.getRawValue() ??
        this.bindingFormControl?.value ??
        '';

      if (!Array.isArray(valueArray) && !isNullOrEmpty(valueArray))
        valueArray = valueArray.split(',');

      this.logger.debug(valueArray);
      if (valueArray.length > 0 && valueArray[0] !== '') {
        this.value?.setValue(valueArray);
      }
    } else {
      this.value?.setValue(this.bindingFormControl?.getRawValue());
    }
  };

  onSubscribeValue(): void {
    this.bindingFormControl?.valueChanges.subscribe((changeValue: any) => {
      this.setValueData();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectOptions']) {
      this.setValueData();
    }
  }

  ngOnInit(): void {
    this.subscription = this.translateService.onLangChange.subscribe((data) => {
      this.setValueData();
    });
    this.onSubscribeValue();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
